<template>
  <i
    aria-hidden="true"
    @click="$emit('click')"
    @mousedown.prevent="$emit('mousedown')"
    @mouseup.prevent="$emit('mouseup')"
    :is="tag"
    :to="to"
    :class="[baseCss, 'outline-none', `${provider !== 'google' ? (provider + ' ' + provider + '-' + name)  : 'material-icons'}`, internalTextColor]"
    :style="{fontSize: `${size}em`, lineHeight: 1}">{{ provider === 'google' ? name : null }}</i>
</template>
<script>
import methods from '../../mixins/methods'
import computed from '../../mixins/computed'
import props from '../../mixins/props'

export default {
  name: 'Icon',
  mixins: [
    props,
    methods,
    computed
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('icon', ['select-none', 'align-middle', 'inline-block'])
    }
  },
  props: {
    tag: {
      type: String,
      default: 'i'
    },
    name: {
      type: String,
      default: 'home'
    },
    to: {
      type: String
    },
    size: {
      type: [Number, String],
      default: 1.5
    },
    color: {
      type: String,
      default: 'black'
    },
    provider: {
      type: String,
      default: 'mdi',
      validator: value => {
        return ['mdi', 'fa', 'google'].includes(value)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/icon/icon.vue